<template>
  <content-page back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">
        Error Logs
      </div>
    </template>
    <div class="pa-2 white rounded" v-if="all.length > 0">
      <div v-for="line, index in all" :key="'log-' + index">
        {{ index + 1}}. {{ displayLine(line) }}
      </div>
    </div>
    <div class="pa-2 white rounded d-flex justify-center" v-else>
      <em>EMPTY</em>
    </div>
  </content-page>
</template>

<script>
import { ContentPage } from '@/components/pages'
import { mapGetters } from 'vuex'

export default {
  components: { ContentPage, },

  computed: mapGetters('console', ['all']),

  methods: {
    displayLine(line) {
      let strings = line.map( item => (typeof item === 'object' ? JSON.stringify(item,null,4) : item))
      return strings.join(', ')
    }
  },
}
</script>
